import CachedIcon from '@mui/icons-material/Cached';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Button, CircularProgress, IconButton, Stack, TextField, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { push } from "connected-react-router";
import dayjs from 'dayjs';
import React, { useEffect } from "react";
import { useCSVDownloader } from 'react-papaparse';
import { connect, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { Path as RoutePath } from "../../../path";
import { actionCreators, ApplicationState, FetchState, selectors } from "../../../store";
import { formatRoundDownDecimal } from "../../../utils";
import ChartPanel, { ChartResult } from "../../chart/ChartPanel";
import { DailyChartLineData } from "../../chart/DailyChart";
import Calendar1 from '../../common/calendar1';
import FetchHelper from "../../FetchHelper";
import DeviceInformation from '../../polling/device/DeviceInformation';
import Calendar2, { HourlyData, MinuteData } from './calendar2';
import './styles.css';

// -------------
// FETCH ID
const fetchId = "GAEX2_LIST";
const formId = "GAEX2_SEARCH_FORM";
const getDevice = "GAEX2_GET_DEVICE";
const menusFetchId = 'MENUS_FETCH';

// -------------
// Props
export type SmartMeasurementDisplayProps = ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps;

// -------------
// Component
export const SmartMeasurementDisplay = (props: SmartMeasurementDisplayProps) => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const mainid = urlParams.get('mainid');
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const dayJapan = ["日", "月", "火", "水", "木", "金", "土"];
    const { CSVDownloader, Type } = useCSVDownloader();
    const { fetchStateMenu,fetchState, backData, onGetAuthRole, onError, onSearch, onErrorSearch, onGetDevice, } = props;
    const [device, setDevice] = React.useState<any>();
    const [pulseType, setPulseType] = React.useState("");
    const [unitFlag, setUnitFlag] = React.useState<number>(1);
    const [modeFlag, setModeFlag] = React.useState(true);
    const [measuredCHFlag, setMeasuredCHFlag] = React.useState(-1);
    const [gaex2List, setGaex2List] = React.useState<any[]>([]);
    const [dateValue, setDateValue] = React.useState(backData ? dayjs(backData).toDate() : new Date());
    const [dateSelect, setDateSelect] = React.useState(backData ? dayjs(backData).toDate() : new Date());
    const [chartLineModel, setChartLineModel] = React.useState<ChartResult>();
    const [dataList, setDataList] = React.useState<any>();
    const [kwhMaxByMonth,setKwhMaxByMonth] = React.useState<any>();
    const [kwhMinByMonth,setKwhMinByMonth] = React.useState<any>();
    const [dayFinalMaxKwh,setDayFinalMaxKwh] = React.useState<any>();
    const [dayFinalMinKwh,setDayFinalMinKwh] = React.useState<any>();
    const [hourFinalMaxKwh,setHourFinalMaxKwh] = React.useState<any>();
    const [hourFinalMinKwh,setHourFinalMinKwh] = React.useState<any>();
    const [minuteFinalMin, setMinuteFinalMin] = React.useState<any>();
    const [minuteFinalMax, setMinuteFinalMax] = React.useState<any>();
    const [fileNameCSV,setFileNameCSV] = React.useState<any>(pulseType === "1" ? "デマンド定期通報":"太陽光定期通報");
    const [loadingDeviceFlag,setLoadingDeviceFlag] = React.useState(false);
    const [loadingFlag, setLoadingFlag] = React.useState(true);
    const [authRole, setAuthRole] = React.useState<any>();
    const [isError,setError] = React.useState<boolean>(false);
    const [chExistInfo, setChExistInfo] = React.useState<any>();
    localStorage.setItem('lastActiveFormPath', RoutePath.SmartSettingMeasurementList);
    localStorage.setItem('title', 'スマート測定表示');

    React.useEffect(()=> {
        if(fetchStateMenu.data){
            setAuthRole(fetchStateMenu.data);
        } else {
            onGetAuthRole();
        }
    },[]);

    React.useEffect(() => {
        const params = createData(dateValue);
        if(backData){
            dispatch({type:"SET_BACK_DATA",payload:{data:null}})
        }
        handleSearchSubmit(params);
    }, []);

    React.useEffect(() => {
        if(dateSelect !== null){
            setError(false)
        }
    },[dateSelect]);

    useEffect(() => {
        const date = new Date();
        let name = date.toLocaleString('en-us', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$3-$1-$2');
        if(unitFlag === 1){
            name += "_スマート測定-月表(負荷電流)_"; 
        }else if(unitFlag === 2){
            name += "_スマート測定-月表(漏電電流)_";
        }
        if(measuredCHFlag !== -1){
            name += `CH${measuredCHFlag}_`;
        }
        if(device){
            name += `${dateValue.getFullYear()}年${dateValue.getMonth()+1}月_${device.customer_name}_${device.id}`
        }
        setFileNameCSV(name);
    },[unitFlag, device, measuredCHFlag, dateValue]);

    const handleExportCSV = () => {
        let result:any = [];
        let headerName = ["月合計","月"];
        result = [];
        headerName = ["日最大","日","曜日"];
        [...Array(24)].forEach((item:any,index:any)=> {
            if(index < 10){
                headerName.push(`0${index}:00`);
                headerName.push(`0${index}:30`);
            }else{
                headerName.push(`${index}:00`);
                headerName.push(`${index}:30`);
            }
        })
        result.push(headerName);
        gaex2List.forEach((item:any)=> {
            const dayData = [];
            dayData.push(getValueData(item.day_kwh));
            dayData.push(getValueData(item.date));
            dayData.push(getValueData(item.day));
            [...Array(48)].forEach(()=>{
                dayData.push("-")
            })
            if(item.data.length > 0){
                const channelKey = `ch${measuredCHFlag}` as keyof MinuteData;
                item.data.forEach((item:HourlyData)=>{
                    const min0Data = item.mins_data.find(m => m.min === 0);
                    const min30Data = item.mins_data.find(m => m.min === 30);
                    if (min0Data && min0Data[channelKey] !== null && min0Data[channelKey] !== undefined) {
                        dayData[Number(item.hour)*2+3] = getValueData(Number(min0Data[channelKey]));
                    }
                    if (min30Data && min30Data[channelKey] !== null && min30Data[channelKey] !== undefined) {
                        dayData[Number(item.hour)*2+4] = getValueData(Number(min30Data[channelKey]));
                    }
                })
            }
            result.push(dayData);
        });
        return result;
    }

    const handleFetchAuthRoleSuccess = (data: any) => {
        console.log('>>> handleSuccess');
        if (data)
            setAuthRole(data);
    };

    const getValueData = (data:any) => {
        if(data != null && data != undefined)
            return data;
        return "-";
    }

    const handleFetchSuccess = (data: any) => {
        setDataList(data);
        setChExistInfo(data?.ch_exist_info);
        let newMeasuredCHFlag = measuredCHFlag;
        const chInfo = data?.ch_exist_info;
        if (chInfo) {
            let chEntry;
            if(measuredCHFlag === -1){
                if(unitFlag === 1){
                    chEntry = Object.entries(chInfo).find(([, value]) => value === 1);
                } else if(unitFlag === 2){
                    chEntry = Object.entries(chInfo).find(([, value]) => value === 2);
                }
                if (chEntry) {
                    const chNum = parseInt(chEntry[0].replace('ch', ''));
                    newMeasuredCHFlag = chNum;
                    setMeasuredCHFlag(chNum);
                }
            }else{
                const allZero = Object.entries(chInfo).every(([, value]) => value === 0);
                if(allZero){
                    newMeasuredCHFlag = -1;
                    setMeasuredCHFlag(-1);
                }
            }
        }
        handleData(data, unitFlag, modeFlag, newMeasuredCHFlag);
        setLoadingFlag(false);
    };

    // デバイス情報を取得する
    const handleGetDevice = (data: any) => {
        setPulseType(data.pulse_type);
        setDevice(data);
        setLoadingDeviceFlag(false);
    };

    const handleData = (data: any, unitFlag: number, modeFlag: boolean, measuredCHFlag: number) => {
        setDayFinalMinKwh(null);
        setMinuteFinalMin(null);
        setHourFinalMinKwh(null);
        setKwhMinByMonth(null);
        setKwhMaxByMonth(null);
        setDayFinalMaxKwh(null);
        setHourFinalMaxKwh(null);
        setMinuteFinalMax(null);
        
        var calendar = (new Array(31)).fill('').map((v, i) => new Date(dateValue.getFullYear(), dateValue.getMonth(), i + 1)).filter(v => v.getMonth() === dateValue.getMonth())
        let newData: any[] = [];
        if (data.days_data === undefined) {
            calendar.forEach(item => {
                var day = dayJapan[item.getDay()];
                newData.push({
                    day: day,
                    date: item.getDate().toString(),
                    month_kwh: 0,
                    day_kwh: "-",
                    data: [],
                    alarm1_kw: 0,
                    alarm2_kw: 0,
                    day_amount:"-"
                })
            });
            setGaex2List(newData);
            onCreateChart(newData, unitFlag);
            onErrorSearch();
        }
        else {
            if(measuredCHFlag == -1){
                calendar.forEach(item => {
                    var day = dayJapan[item.getDay()];
                    newData.push({
                        day: day,
                        date: item.getDate().toString(),
                        month_kwh: 0,
                        day_kwh: "-",
                        data: [],
                        alarm1_kw: 0,
                        alarm2_kw: 0,
                        day_amount:"-"
                    })
                });
                setGaex2List(newData);
                onCreateChart(newData, unitFlag);
                return;
            }
                if (data.days_data.length > 0) {
                    let kwhMaxByMonth:any;
                    let kwhMinByMonth:any;
                    switch(unitFlag){
                        case 1:
                            kwhMaxByMonth = 0;
                            kwhMinByMonth = Number.MAX_VALUE;
                            calendar.forEach(item => {
                                var day = dayJapan[item.getDay()];
                                var list = data.days_data.filter((x: any) => x.day === item.getDate());
                                if(list.length > 0){
                                    const hoursData = list[0]?.hours_data ?? [];
                                    const day_data_max = hoursData.length > 0
                                        ? hoursData.reduce((a: any, b: any) => {
                                            const aMax = Math.max(...(a.mins_data?.map((m: any) => m[`ch${measuredCHFlag}`] || 0) || [0]));
                                            const bMax = Math.max(...(b.mins_data?.map((m: any) => m[`ch${measuredCHFlag}`] || 0) || [0]));
                                            return aMax > bMax ? a : b;
                                        })
                                        : null;
                                    const day_data_min = hoursData.length > 0
                                        ? hoursData.reduce((a: any, b: any) => {
                                            const aMin = Math.min(...(a.mins_data?.map((m: any) => m[`ch${measuredCHFlag}`] || 0) || [0]));
                                            const bMin = Math.min(...(b.mins_data?.map((m: any) => m[`ch${measuredCHFlag}`] || 0) || [0]));
                                            return aMin < bMin ? a : b;
                                        })
                                        : null;
                                    if(day_data_max){
                                        const maxValue = Math.max(...(day_data_max.mins_data?.map((m: any) => m[`ch${measuredCHFlag}`] || 0) || [0]));
                                        const maxMinuteData = day_data_max.mins_data?.findLast((m: any) =>
                                            (m[`ch${measuredCHFlag}`] || 0) === maxValue
                                        );
                                        if(kwhMaxByMonth <= maxValue){
                                            kwhMaxByMonth = maxValue;
                                            setDayFinalMaxKwh(item.getDate());
                                            setHourFinalMaxKwh(day_data_max.hour);
                                            setMinuteFinalMax(maxMinuteData?.min || 0);
                                        }
                                    }
                                    if(day_data_min){
                                        const minValue = Math.min(...(day_data_min.mins_data?.map((m: any) => m[`ch${measuredCHFlag}`] || 0) || [0]));
                                        const minMinuteData = day_data_min.mins_data?.findLast((m: any) => 
                                            (m[`ch${measuredCHFlag}`] || 0) === minValue
                                        );
                                        if(kwhMinByMonth >= minValue){
                                            kwhMinByMonth = minValue;
                                            setDayFinalMinKwh(item.getDate());
                                            setHourFinalMinKwh(day_data_min.hour);
                                            setMinuteFinalMin(minMinuteData?.min || 0);
                                        }
                                    }
                                }
                                let dayMaxValue:any = "-";
                                if(list.length > 0){
                                    const hoursData = list[0]?.hours_data ?? [];
                                    let allValuesInDay: number[] = [];
                                    
                                    hoursData.forEach((hourData: any) => {
                                        if(hourData.mins_data){
                                            hourData.mins_data.forEach((minData: any) => {
                                                const channelValue = minData[`ch${measuredCHFlag}`];
                                                if(channelValue !== null && channelValue !== undefined){
                                                    allValuesInDay.push(Number(channelValue));
                                                }
                                            });
                                        }
                                    });
                                    
                                    if(allValuesInDay.length > 0){
                                        dayMaxValue = Math.max(...allValuesInDay);
                                    }
                                }
                                
                                newData.push({
                                    day: day,
                                    date: item.getDate().toString(),
                                    month_kwh: data?.month_kwh ?? "",
                                    day_kwh: dayMaxValue,
                                    data: (list.length > 0 ? list[0].hours_data : []),
                                    alarm1_kw: data?.alarm1_kw ?? 0,
                                    alarm2_kw: data?.alarm2_kw ?? 0
                                })
                            });
                            setKwhMaxByMonth(kwhMaxByMonth);
                            setKwhMinByMonth(kwhMinByMonth === Number.MAX_VALUE ? 0 : kwhMinByMonth);
                            break;
                        case 2:
                            kwhMaxByMonth = 0;
                            kwhMinByMonth = Number.MAX_VALUE;
                            calendar.forEach(item => {
                                var day = dayJapan[item.getDay()];
                                var list = data.days_data.filter((x: any) => x.day === item.getDate());
                                if(list.length > 0){
                                    const hoursData = list[0]?.hours_data ?? [];
                                    const day_data_max = hoursData.length > 0
                                        ? hoursData.reduce((a: any, b: any) => {
                                            const aMax = Math.max(...(a.mins_data?.map((m: any) => m[`ch${measuredCHFlag}`] || 0) || [0]));
                                            const bMax = Math.max(...(b.mins_data?.map((m: any) => m[`ch${measuredCHFlag}`] || 0) || [0]));
                                            return aMax > bMax ? a : b;
                                        })
                                        : null;
                                    const day_data_min = hoursData.length > 0
                                        ? hoursData.reduce((a: any, b: any) => {
                                            const aMin = Math.min(...(a.mins_data?.map((m: any) => m[`ch${measuredCHFlag}`] || 0) || [0]));
                                            const bMin = Math.min(...(b.mins_data?.map((m: any) => m[`ch${measuredCHFlag}`] || 0) || [0]));
                                            return aMin < bMin ? a : b;
                                        })
                                        : null;
                                    if(day_data_max){
                                        const maxValue = Math.max(...(day_data_max.mins_data?.map((m: any) => m[`ch${measuredCHFlag}`] || 0) || [0]));
                                        const maxMinuteData = day_data_max.mins_data?.findLast((m: any) =>
                                            (m[`ch${measuredCHFlag}`] || 0) === maxValue
                                        );
                                        if(kwhMaxByMonth <= maxValue){
                                            kwhMaxByMonth = maxValue;
                                            setDayFinalMaxKwh(item.getDate());
                                            setHourFinalMaxKwh(day_data_max.hour);
                                            setMinuteFinalMax(maxMinuteData?.min || 0);
                                        }
                                    }
                                    if(day_data_min){
                                        const minValue = Math.min(...(day_data_min.mins_data?.map((m: any) => m[`ch${measuredCHFlag}`] || 0) || [0]));
                                        const minMinuteData = day_data_min.mins_data?.findLast((m: any) => 
                                            (m[`ch${measuredCHFlag}`] || 0) === minValue
                                        );
                                        if(kwhMinByMonth >= minValue){
                                            kwhMinByMonth = minValue;
                                            setDayFinalMinKwh(item.getDate());
                                            setHourFinalMinKwh(day_data_min.hour);
                                            setMinuteFinalMin(minMinuteData?.min || 0);
                                        }
                                    }
                                }
                                
                                let dayMaxValue:any = "-";
                                if(list.length > 0){
                                    const hoursData = list[0]?.hours_data ?? [];
                                    let allValuesInDay: number[] = [];
                                    
                                    hoursData.forEach((hourData: any) => {
                                        if(hourData.mins_data){
                                            hourData.mins_data.forEach((minData: any) => {
                                                const channelValue = minData[`ch${measuredCHFlag}`];
                                                if(channelValue !== null && channelValue !== undefined){
                                                    allValuesInDay.push(Number(channelValue));
                                                }
                                            });
                                        }
                                    });
                                    
                                    if(allValuesInDay.length > 0){
                                        dayMaxValue = Math.max(...allValuesInDay);
                                    }
                                }
                                
                                newData.push({
                                    day: day,
                                    date: item.getDate().toString(),
                                    month_kwh: data?.month_kwh ?? "",
                                    day_kwh: dayMaxValue,
                                    data: (list.length > 0 ? list[0].hours_data : []),
                                    alarm1_kw: data?.alarm1_kw ?? 0,
                                    alarm2_kw: data?.alarm2_kw ?? 0
                                })
                            });
                            setKwhMaxByMonth(kwhMaxByMonth);
                            setKwhMinByMonth(kwhMinByMonth === Number.MAX_VALUE ? 0 : kwhMinByMonth);
                            break;
                    }
                } else {
                    calendar.forEach(item => {
                        var day = dayJapan[item.getDay()];
                        newData.push({
                            day: day,
                            date: item.getDate().toString(),
                            month_kwh: 0,
                            day_kwh: "-",
                            data: [],
                            alarm1_kw: 0,
                            alarm2_kw: 0,
                            day_amount:"-"
                        })
                    });
                }
                setGaex2List(newData);
                onCreateChart(newData,unitFlag);
        }
    }

    const handleError = (success: boolean, data: any, error: any) => {
        onError(success, data, error);
        setLoadingDeviceFlag(false);
    }

    const CreateDataChartLine = (data: any) => {
        return {
            dataChart1: data.map((item: any) => formatRoundDownDecimal(item.day_kwh.toString(),0,true)),
        } as DailyChartLineData;
    };

    const reCreateDataChartLine = (data: any, unitFlag: number) => {
        return {
            chartId: 7,
            labels: data.map((item: any) => item.date + '日(' + item.day + ')'),
            dataChart: CreateDataChartLine(data),
            unit: unitFlag == 1  ? "A" : "mA"
        } as ChartResult;
    };

    const onCreateChart = (data: any, unitFlag: number) => {
        setChartLineModel(undefined);

        setTimeout(() => {
            const chartLineData = reCreateDataChartLine(data, unitFlag);
            setChartLineModel(chartLineData);
        },0);
    }

    const createData = (value: Date) => {
        const params = new Map<string, any>();
        params.set("code", "FAEX1");
        params.set("mainid", mainid);
        params.set("year", value.getFullYear());
        params.set("month", (value.getMonth() + 1).toString().padStart(2, "0"));
        return params;
    };

    const handleErrorSearch = () => {
        setLoadingFlag(false);
        handleData([], unitFlag, modeFlag, measuredCHFlag);
    }

    // 検索実行
    const handleSearchSubmit = (params: any) => {
        let isError = false;

        if (isEmpty(mainid)) isError = true;

        onGetDevice(mainid)
        setLoadingDeviceFlag(true);

        if (!isError) {
            onSearch(params);
        } else {
            handleErrorSearch();
        }
    }

    const isEmpty = (value: any) => {
        return (value === null || value?.length <= 0);
    }

    //タブ表示ボタンスタイル
    const buttonStyle1 = {
        backgroundColor:  unitFlag === 1  ? '#997a00' : '#e6b800',
        color: 'white',
        height: '40px',
        margin: 'auto 0',
        border: '0.5px solid #997a00',
        borderRadius: '9px 0 0 9px',
    }

    const buttonStyle2 = {
        backgroundColor:  unitFlag === 2  ? '#997a00' : '#e6b800',
        color: 'white',
        height: '40px',
        margin: 'auto 0',
        border: '0.5px solid #997a00',
        borderRadius: '0px 9px 9px 0px',
    }

    const buttonStyle4 = {
        backgroundColor: modeFlag ? '#997a00' : '#e6b800',
        color: 'white',
        height: '40px',
        margin: 'auto 0',
        border: '0.5px solid #997a00',
        borderRadius: '9px 0 0 9px',
        
    }

    const buttonStyle5 = {
        backgroundColor: modeFlag ? '#e6b800' : '#997a00',
        color: 'white',
        height: '40px',
        margin: 'auto 0',
        border: '0.5px solid #997a00',
        borderRadius: '0 9px 9px 0',
    }

    const buttonStyle6 = {
        backgroundColor: measuredCHFlag === 1  ? '#997a00' : '#e6b800',
        color: 'white',
        height: '40px',
        margin: 'auto 0',
        border: '0.5px solid #997a00',
        borderRadius: '9px 0 0 9px',
    }

    const buttonStyle7 = {
        backgroundColor: measuredCHFlag === 2  ? '#997a00' : '#e6b800',
        color: 'white',
        height: '40px',
        margin: 'auto 0',
        border: '0.5px solid #997a00',
        borderRadius: '0px 0px 0px 0px',
    }

    const buttonStyle8 = {
        backgroundColor: measuredCHFlag === 3  ? '#997a00' : '#e6b800',
        color: 'white',
        height: '40px',
        margin: 'auto 0',
        border: '0.5px solid #997a00',
        borderRadius: '0px 0px 0px 0px',
    }

    const buttonStyle9 = {
        backgroundColor: measuredCHFlag === 4  ? '#997a00' : '#e6b800',
        color: 'white',
        height: '40px',
        margin: 'auto 0',
        border: '0.5px solid #997a00',
        borderRadius: '0px 0px 0px 0px',
    }

    const buttonStyle10 = {
        backgroundColor: measuredCHFlag === 5  ? '#997a00' : '#e6b800',
        color: 'white',
        height: '40px',
        margin: 'auto 0',
        border: '0.5px solid #997a00',
        borderRadius: '0px 0px 0px 0px',
    }

    const buttonStyle11 = {
        backgroundColor: measuredCHFlag === 6  ? '#997a00' : '#e6b800',
        color: 'white',
        height: '40px',
        margin: 'auto 0',
        border: '0.5px solid #997a00',
        borderRadius: '0px 9px 9px 0px',
    }
    
    // キャンセル
    const handleCancel = () => {
        let path = sessionStorage.getItem("references");
        if(!path){
            if(authRole.auth_role_map["LM-telemetry-view"])
            {
                if(pulseType == "1" && (authRole.code_restriction_array?.length == 0 || authRole.code_restriction_array?.includes("GADEMAND"))){
                    let newPath = "/telemetry/ga";
                    let newUrlPath = (urlParams.get('path'))
                    if(newUrlPath){
                        newUrlPath = (urlParams.get('path') ?? "root");
                        newPath +='?path=' + newUrlPath;
                        newPath += id ? '&id=' + id : "";
                        if (newUrlPath=="customer") {
                            newPath += '&customer_id=' + (urlParams.get('customer_id') ?? '');
                        }
                    }else{
                        newPath += "?path=root";
                    }
                    if(newPath){
                        navigate(newPath, { replace: true });
                        return;
                    }
                }
                if(pulseType == "2" && (authRole.code_restriction_array?.length == 0 || authRole.code_restriction_array?.includes("GASOLAR"))){
                    let newPath = "/telemetry/ga2";
                    let newUrlPath = (urlParams.get('path'))
                    if(newUrlPath){
                        newUrlPath = (urlParams.get('path') ?? "root");
                        newPath +='?path=' + newUrlPath;
                        newPath += id ? '&id=' + id : "";
                        if (newUrlPath=="customer") {
                            newPath += '&customer_id=' + (urlParams.get('customer_id') ?? '');
                        }
                    }else{
                        newPath += "?path=root";
                    }
                    if(newPath){
                        navigate(newPath, { replace: true });
                        return;
                    }
                }
            }
            if(authRole.auth_role_map["LM-smonitor-view"]){
                if(pulseType == "1" && authRole.code_restriction_array?.includes("GADEMAND")){
                    navigate(RoutePath.SmartDemandList);
                    return;
                }
                if(pulseType == "2" && authRole.code_restriction_array?.includes("GASOLAR")){
                    navigate(RoutePath.SmartSolarList);
                    return;
                }
            }
            navigate("/");
            return;
        }
        sessionStorage.removeItem('references');
        let urlPath = (urlParams.get('path'))
        if(urlPath){
            urlPath = (urlParams.get('path') ?? "root");
            path +='?path=' + urlPath;
            path += id ? '&id=' + id : "";
            if (urlPath=="customer") {
                path += '&customer_id=' + (urlParams.get('customer_id') ?? '');
            }
        }else{
            path += id ? '?id=' + id : "";
        }
        if(path)
        {
            navigate(path, { replace: true });
        }
    }

    const handleChangeUnit = (flag: number) => {
        if (unitFlag !== flag) {
            setUnitFlag(flag);
            setMeasuredCHFlag(-1);
            handleData(dataList, flag, modeFlag, -1);
        }
    }

    const handleChangeMeasuredCH = (flag: number) => {
        if (measuredCHFlag !== flag) {
            setMeasuredCHFlag(flag);
            handleData(dataList, unitFlag, modeFlag, flag);
        }
    }

    const handleChangeMode = (flag: boolean) => {
        if (modeFlag !== flag) {
            setModeFlag(flag);
            handleData(dataList, unitFlag, flag, measuredCHFlag);
        }
    }

    // 翌月のデータを取得する
    const onRight = () => {
        var tempDate = new Date(dateValue.getFullYear(), dateValue.getMonth() + 1);
        setDateValue(tempDate);
        setDateSelect(tempDate);
        setLoadingFlag(true);
        handleSearchSubmit(createData(tempDate));
    }

    // 前月のデータを取得する
    const onLeft = () => {
        var tempDate = new Date(dateValue.getFullYear(), dateValue.getMonth());
        tempDate.setMonth(tempDate.getMonth() - 1)
        setDateValue(tempDate);
        setDateSelect(tempDate);
        setLoadingFlag(true);
        handleSearchSubmit(createData(tempDate));
    }

    // データをリフレッシュする
    const handleRefresh = () => {
        if (!isNaN(dateSelect.getTime())) {
            setLoadingFlag(true);
            setDateValue(dateSelect);
            handleSearchSubmit(createData(dateSelect));
        }
    }
    
    // 当月のデータを取得する
    const handleGetLatestData = () => {
        setLoadingFlag(true);
        var date = new Date();
        setDateSelect(date);
        setDateValue(date);
        handleSearchSubmit(createData(date));
    }

    return (
        <>
            {(loadingFlag || loadingDeviceFlag) && (
                <div style={{ top: "0px", left: '0px', position: "fixed", zIndex: 1200, width: '100%', height: '100%', padding: '50vh 50% 50% 50%', background: '#00000030' }}>
                    <CircularProgress />
                </div>
            )}
            <div style={{ height:"auto", margin: '0 1%', textAlign:"center", overflow: 'auto' }}>
                <div style={{ textAlign: "left"}}>
                <DeviceInformation titleFlag={true} deviceInformation={device} mainid={device?.id ?? ""} title="定期通報"   isDisplayDeviceInfo={true} isShowMenuButton ={false} ></DeviceInformation>
                </div>
                    <Box>
                    <Stack direction="row">
                        <div style={{ width: '100%', display: 'flex', marginTop: '10px', alignItems: 'center' }}>
                            <Typography variant="body1" style={{ color: "gray" }} mr={2}>単位</Typography>
                            <Button style={{ textTransform: 'none' }} sx={buttonStyle1} variant="text" onClick={e => handleChangeUnit(1)}>A（負荷電流）</Button>
                            <Button
                                style={{ textTransform: 'none' }}
                                sx={buttonStyle2}
                                variant="text"
                                onClick={e => handleChangeUnit(2)}
                            >
                                mA（漏電電流）
                            </Button>

                            <Typography variant="body1" style={{ color: "gray" }} ml={2} mr={2}>測定CH</Typography>
                            {Array.from({ length: 6 }, (_, i) => {
                                const chNum = i + 1;
                                const buttonStyles = [buttonStyle6, buttonStyle7, buttonStyle8, buttonStyle9, buttonStyle10, buttonStyle11];
                                const isDisabled = chExistInfo && (
                                    (unitFlag === 1 && chExistInfo[`ch${chNum}`] !== 1) ||
                                    (unitFlag === 2 && chExistInfo[`ch${chNum}`] !== 2)
                                );
                                return (
                                    <Button
                                        key={`ch-btn-${chNum}`}
                                        style={{ textTransform: 'none', opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? 'none' : 'auto' }}
                                        disabled={isDisabled}
                                        sx={buttonStyles[i]}
                                        variant="text"
                                        onClick={e => handleChangeMeasuredCH(chNum)}
                                    >
                                        {`CH${chNum}`}
                                    </Button>
                                );
                            })}
                            <Typography variant="body1" style={{ color: "gray" }} ml={2} mr={2}>種類</Typography>
                            <Button style={{ textTransform: 'none'}} sx={buttonStyle4} variant="text" onClick={e => handleChangeMode(true)}>表</Button>
                            <Button style={{ textTransform: 'none' }} sx={buttonStyle5} variant="text" onClick={e => handleChangeMode(false)}>グラフ</Button>
                            <div style={{ marginInlineStart: 'auto', pointerEvents: fetchState.loading ? "none" : "auto" }}>
                                {modeFlag && measuredCHFlag !== -1 &&
                                    <CSVDownloader
                                    type={Type.Link}
                                    filename={fileNameCSV}
                                    bom={true}
                                    data={handleExportCSV}
                                    >
                                        <Button variant="outlined" size="small" style={{ margin: 'auto 10px auto 0',padding:"7px" }}>CSV</Button>
                                    </CSVDownloader>
                                }
                                <Button variant="outlined" size="small" style={{ height: '40px', borderRadius: '9px 0 0 9px' }} onClick={onLeft} >{<ChevronLeftIcon />}前月</Button>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        inputFormat="YYYY.MM"
                                        views={["year", "month"]}
                                        openTo="month"
                                        renderInput={(props: any) => (
                                            <TextField
                                                size="small"
                                                style={{ maxWidth:"125px",fontSize:"0.5rem", marginLeft: '-1px' }}
                                                error={!!isError}
                                                sx={{
                                                    fieldset: {
                                                        border: "1px solid rgba(24, 144, 255, 0.5)",
                                                        borderWidth: "1px 1px 1px 1px",
                                                        zIndex: "1",
                                                        borderRadius: "unset"
                                                    }
                                                }}
                                                {...props} />
                                        )}
                                        value={dateSelect}
                                        onChange={(newValue: any) => {
                                            if(newValue !== null){
                                                setDateSelect(newValue.$d);
                                            }else{
                                                setError(true);
                                            }
                                        }}                            
                                        disableMaskedInput={false}
                                    />
                                </LocalizationProvider>
                                <Button variant="outlined" size="small" style={{ height: '40px', borderRadius: '0px 0px', marginLeft: '-1px' }} onClick={onRight}>翌月{<ChevronRightIcon />}</Button>
                                <Button variant="outlined" size="small" style={{ height: '40px', borderRadius: '0px 9px 9px 0px', borderWidth: "1px 1px 1px 1px", marginLeft: '-1px' }} onClick={handleGetLatestData}>最新</Button>
                                <IconButton aria-label="edit" >
                                    <CachedIcon fontSize="medium" style={{ color: '#1890ff' }} onClick={handleRefresh} />
                                </IconButton>
                            </div>
                        </div>
                    </Stack>
                    </Box>
                
                {!loadingFlag && <>
                    <div style={{ display: "flex", alignItems: "baseline" }}>
                        <Typography variant="h2" mr={4} style={{ fontWeight: "normal" }}>{dateValue.getFullYear()}年{dateValue.getMonth() + 1}月</Typography>
                        <Typography variant="h4" mr={1} style={{ color: "gray", fontWeight: "normal" }}>最大電流：
                        </Typography>
                        {
                            kwhMaxByMonth !== null && dayFinalMaxKwh !== null && hourFinalMaxKwh !== null && minuteFinalMax !== null ? (
                                <>
                                    <Typography variant="h3" mr={1} style={{ color: "red" }}>{formatRoundDownDecimal(kwhMaxByMonth,0)} {unitFlag == 1 ? "A" : "mA"}</Typography>
                                    <Typography variant="h4" style={{ color: "gray", fontWeight: "normal" }}>{`(${dayFinalMaxKwh}日 ${hourFinalMaxKwh !== null && minuteFinalMax !== null ? String(hourFinalMaxKwh).padStart(2, '0') + ":" + String(minuteFinalMax).padStart(2, '0') : "--:--"})`}</Typography>
                                </>
                            ) : (
                                <Typography variant="h3" style={{ color: "gray", fontWeight: "normal" }}>-</Typography>
                            )
                        }
                        <Typography variant="h4" mr={1} style={{ color: "gray", fontWeight: "normal" }}>　、最小電流：</Typography>
                        {
                            kwhMinByMonth !== null && dayFinalMinKwh !== null && hourFinalMinKwh !== null && minuteFinalMin !== null ? (
                                <>
                                <Typography variant="h3" mr={1} style={{ color: "red" }}>{formatRoundDownDecimal(kwhMinByMonth,0)} {unitFlag == 1 ? "A" : "mA"}</Typography>
                                <Typography variant="h4" style={{ color: "gray", fontWeight: "normal" }}>{`(${dayFinalMinKwh}日 ${hourFinalMinKwh !== null && minuteFinalMin !== null ? String(hourFinalMinKwh).padStart(2, '0') + ":" + String(minuteFinalMin).padStart(2, '0') : "--:--"})`}</Typography>
                                </>
                            ) : (
                                <Typography variant="h3" style={{ color: "gray", fontWeight: "normal" }}>-</Typography>
                            )
                        }
                    </div>
                    <div className={'TableStyle'} style={{ height: 'calc(100vh - 315px)', width: '100%', overflowY: 'auto' }}>
                        {
                            modeFlag &&
                            <>
                                {unitFlag ===1 && 
                                    <>
                                        <table className={'tableFixHead'} style={{ width: '100%' }} cellPadding={0} cellSpacing={0}>
                                            <thead>
                                                <Calendar1 month={dateValue.getMonth() + 1} year={dateValue.getFullYear()} mode={'calendar2'}></Calendar1 >
                                            </thead>
                                            {
                                                gaex2List.map((row) => {
                                                    return (
                                                        <>
                                                            <Calendar2 minuteFinalMax={minuteFinalMax} final_day_max_kw={dayFinalMaxKwh} hourFinalMax={hourFinalMaxKwh} max_kw_by_month={kwhMaxByMonth} calendarItem={row} mode={'calendar2'} measuredCHFlag={measuredCHFlag}></Calendar2>
                                                        </>
                                                    );
                                                })
                                            }
                                        </table>
                                    </>
                                }
                                {unitFlag === 2 &&
                                    <>
                                        <table className={'tableFixHead'} style={{ width: '100%' }} cellPadding={0} cellSpacing={0}>
                                            <thead>
                                                <Calendar1 month={dateValue.getMonth() + 1} year={dateValue.getFullYear()} mode={'calendar2'}></Calendar1 >
                                            </thead>
                                            {
                                                gaex2List.map((row) => {
                                                    return (
                                                        <>
                                                            <Calendar2 minuteFinalMax={minuteFinalMax} final_day_max_kw={dayFinalMaxKwh} hourFinalMax={hourFinalMaxKwh} max_kw_by_month={kwhMaxByMonth} calendarItem={row} mode={'calendar2'} measuredCHFlag={measuredCHFlag}></Calendar2>
                                                        </>
                                                    );
                                                })
                                            }
                                        </table>
                                    </>
                                }
                            </>
                        }
                        {unitFlag === 1 && !modeFlag &&
                            <ChartPanel chartModel={chartLineModel} />
                        }
                        {unitFlag === 2 && !modeFlag &&
                            <ChartPanel chartModel={chartLineModel} />
                        }
                    </div>
                    <Stack direction='row' justifyContent="flex-end" spacing={2} sx={{ mt: 2, mr: 2 }}>
                        <Button color="inherit" variant="contained" onClick={handleCancel}>戻る</Button>
                    </Stack>
                </>
                }
            </div>
            <FetchHelper fetchId={fetchId} onComplete={(success, data, error) =>
                success ? handleFetchSuccess(data) : handleError(success, data, error)} />
            <FetchHelper fetchId={getDevice} onComplete={(success, data, error) => success ? handleGetDevice(data) : handleError(success, data, error)} />
            <FetchHelper fetchId={menusFetchId} onComplete={(success, data, error) => success ? handleFetchAuthRoleSuccess(data) : handleError(success, data, error)} />
        </>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
    fetchStateMenu: selectors.getFetchState(
        state,
        menusFetchId
    ) as FetchState,
    formState: selectors.getFormState(state, formId),
    backData:state.app.backData,
});

const mapDispatchToProps = {
    onGetAuthRole: () => actionCreators.fetch(menusFetchId, `/master/menus/get`, 'GET', null),
    onSearch: (params: { [key: string]: any }) => actionCreators.fetch(fetchId, `/telemetry/get`, "GET", params),
    onGetDevice: (id: string | null) => actionCreators.fetch(getDevice, `/master/gateways/get?id=${id}`, "GET", null),
    onChangePageSize: (pageSize: number) => actionCreators.setPageSize(pageSize),
    onShowDetailPage: (id: string) => push(RoutePath.Edit212 + `/${id}`),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "デマンド－月表検索",
            body: "遠方監視管理一覧を検索できません。" + error,
        }),
    onErrorSearch: () =>
        actionCreators.showMessage({
            type: "error",
            title: "デマンド－月表検索",
            body: "デマンド－月表を検索できません。",
        }),
    onSetSearchParams: (params: string) => actionCreators.setSearchParams(params),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SmartMeasurementDisplay as any);
